<template>
    <div style="background-color: white;" :style="{ 'background-image': `url(${bg_login})`, 'background-size': `${bgSize}`, 'background-repeat': 'no-repeat', 'height': `${windowHeight}px` }"></div>
</template>
<script>
export default ({
    props: {
        colRef: {
            required: true
        }
    },
    data() {
        return {
            windowHeight: 0,
			bg_login: '',
			bgSize: '',
        }
    },
    mounted() {
		if (this.$route.meta.bg_login !== undefined) {
			this.bg_login = this.$route.meta.bg_login;
		}
        this.$nextTick(this.setupResizeListener);
	},
    methods: {
		setupResizeListener() {
			this.handleResize(); // Llamamos al método inicialmente para establecer el tamaño de fondo
			window.addEventListener('resize', this.handleResize);
		},
		removeResizeListener() {
			window.removeEventListener('resize', this.handleResize);
		},
		handleResize() {			
			// const colElement = this.colRef; // Eliminamos el acceso a $el
            // console.log(this.colRef)
			if (this.colRef) {
				this.updateBgSize(this.colRef)
			}
		},
		updateBgSize(colElement) {	
			const colWidth = colElement.$el.offsetWidth;
            this.windowHeight = window.innerHeight;
			const colHeight = window.innerHeight;			
			if (colWidth !== 0 || colHeight !== 0 ) {
				// console.log(colElement)
				// console.log(colHeight)
				this.bgSize = `${colWidth}px ${colHeight}px`;
				// console.log(this.bgSize);
			}
		}
	},
})

</script>